import React, { useEffect, useState, useContext, useRef } from 'react';
import FormContext from '../../../helpers/formContext';
import InputText from '../../elements/InputText';
import InputTextArea from '../../elements/InputTextArea';
import RenderErrors from '../../elements/RenderErrors';
import { Dropdown } from 'primereact/dropdown';
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

function FormInputs({ show = ["all"], hide = [], showLabel=true}){
    const base_root = window.location.host;
    const {
        form_data,
        site_options,
        removeErrors, errors,
        inputChange,
        inputChangeAmount
    } = useContext(FormContext);

    // useEffect(() => {
    //     console.log('site_options', site_options)
    // }, []);

    function displayLabel(field_label, custom_field_label = '', is_required){
        let label = custom_field_label ?? field_label

        if(showLabel){
            if(is_required){
                return <>{label}<span className="text-error">*</span></>
            }
            else{
                return label
            }
        }
        return;
    }

    function errorInput(field_name){
        if(errors.hasOwnProperty(field_name)){
            return ' border-danger border border-2'
        }
    }

    function isVisible(field, allValues) {
        if (typeof field !== "string" || field.trim() === "") return true;

        let parsedField;
        try {
            parsedField = JSON.parse(field);
        } catch (e) {
            return true; // fallback: show field if condition can't be parsed
        }

        const cond = parsedField?.visibility?.condition || parsedField?.visibility;
        if (!cond) return true;

        const targetValue = allValues[cond.field];
        switch (cond.operator) {
            case "equals":
            return targetValue == cond.value;
            case "not_empty":
            return targetValue !== undefined && targetValue !== "";
            case "in":
            return Array.isArray(cond.value) && cond.value.includes(targetValue);
            default:
            return true;
        }
    }

    function displayInputs(){
        let input_fields = []

        if(Object.keys(site_options.fields).length > 0){

            input_fields = Object.entries(site_options.fields).map(([index, field]) => {
                const {field_name, field_label, field_type, option_list, is_required, custom_field_label, visibility, conditions} = field;

                let column_class = 'col-lg-6 mb-3'

                if(field_name === 'address'){
                    column_class =  'col-lg-12 mb-3';
                }
                else if(field_name === 'levelup_campaigns'){
                    column_class =  'col-lg-12 mt-4';
                }
                else if(site_options.form_template === 'self-service-dc' && (field_name === 'campaigns' || field_name === 'campaign' || field_name === 'campaign_specific')){
                    column_class =  'col-lg-12 mt-2';
                }
                else if (field_name === 'sponsorship_motivation' && site_options.form_template === 'sponsorship') {
                    column_class = 'col-lg-12 mb-3';
                }


                if(!isVisible(conditions, form_data)) return

                //if(visibility != 3 && visibility != form_data['payment_type']) return
                
                let output = ''
                if(show.includes('all') || show.includes(field_name)){
                    if(field_type == 'text'){
                        output =    <div className={column_class} key={`column-${field_name}`}>
                                        <InputText
                                            id={'input-' + field_name} 
                                            name={field_name} 
                                            value={form_data[field_name]}    
                                            placeholder={ custom_field_label || field_label } 
                                            label={displayLabel(field_label, custom_field_label, is_required)} 
                                            labelClass="form-label"
                                            tagClass={`form-control mb-0${errorInput(field_name)}`}
                                            onChange={inputChange}
                                            onFocus={removeErrors}
                                            // readOnly={profile_data[field_name]}
                                        />
                                        <RenderErrors 
                                            errors={errors} 
                                            name={field_name} 
                                            className="text-error fs-7"
                                        />
                                    </div>;
                    }
                    else if(field_type == 'textarea'){
                        output =    <div className={column_class} key={`column-${field_name}`}>
                                        <InputTextArea
                                            id={'input-' + field_name} 
                                            name={field_name} 
                                            value={form_data[field_name]}        
                                            placeholder={ field_label } 
                                            labelClass="form-label"
                                            label={displayLabel(field_label, custom_field_label, is_required)} 
                                            //tagClass="form-control mb-0"
                                            tagClass={`form-control mb-0${errorInput(field_name)}`}
                                            onChange={inputChange}
                                            onFocus={removeErrors}
                                        />
                                        <RenderErrors 
                                            errors={errors} 
                                            name={field_name} 
                                            className="text-error fs-7"
                                        />
                                    </div>;
                    }
                    else if(field_type == 'email'){
                        output =    <div className={column_class} key={`column-${field_name}`}>
                                        <InputText
                                            id={'input-' + field_name} 
                                            name={field_name} 
                                            value={form_data[field_name]}      
                                            placeholder={ field_label } 
                                            labelClass="form-label"
                                            label={displayLabel(field_label, custom_field_label, is_required)} 
                                            //tagClass="form-control mb-0"
                                            tagClass={`form-control mb-0${errorInput(field_name)}`}
                                            type="email"
                                            onChange={inputChange}
                                            onFocus={removeErrors}
                                            // readOnly={profile_data[field_name]}
                                        />
                                        <RenderErrors 
                                            errors={errors} 
                                            name={field_name} 
                                            className="text-error fs-7"
                                        />
                                    </div>;
                    }
                    else if(field_type == 'mobile'){
                        output =    <div className={column_class} key={`column-${field_name}`}>
                                        {/* <InputNumber
                                            id={'input-' + field_name} 
                                            name={field_name} 
                                            value={form_data[field_name]}      
                                            placeholder={ field_label } 
                                            labelClass="form-label"
                                            label={displayLabel(field_label, custom_field_label, is_required)} 
                                            //tagClass="form-control mb-0"
                                            tagClass={`form-control mb-0${errorInput(field_name)}`}
                                            onChange={inputChange}
                                            onFocus={removeErrors}
                                            // readOnly={profile_data[field_name]}
                                        />                                     */}
                                        <label>{displayLabel(field_label, custom_field_label, is_required)}</label>
                                        <PhoneInput
                                            id={'input-' + field_name} 
                                            defaultCountry="PH"
                                            placeholder={ field_label } 
                                            value={form_data.mobile_no}
                                            onChange={(e)=>inputChange({'target': {name:field_name, value: e}})}
                                            name={field_name} 
                                            onFocus={removeErrors}
                                            className={`form-controls mb-0 ${errorInput(field_name)}`}
                                        />
                                        
                                        <RenderErrors 
                                            errors={errors} 
                                            name={field_name} 
                                            className="text-error fs-7"
                                        />
                                    </div>;
                    }
                    else if(field_type == 'option'){
                        const options = field.option_list;
                        let optionProps = {value:'id', label:'name'}
                        let optionLabel = 'name'
                        let optionValue = 'id'

                        if(field_name == 'country'){
                            optionProps =  {value:'name', label:'name'};
                            optionLabel = 'name'
                            optionValue = 'name'
                        }

                        output =    <div className={column_class} key={`column-${field_name}`}>
                                        {/* <DropDownSelection
                                            label={displayLabel(field_label, custom_field_label, is_required)} 
                                            name={field_name} 
                                            placeholder={ 'Select ' + field_label } 
                                            value={form_data[field_name]}      
                                            labelClass="form-label"
                                            tagClass="form-select mb-0"
                                            onChange={inputChange}
                                            onFocus={removeErrors}
                                            optionList={options}
                                            optionProps ={optionProps}
                                            // disabled={profile_data[field_name]}
                                        /> */}
                                        <label htmlFor={'input-' + field_name}>{displayLabel(field_label, custom_field_label, is_required)}</label>
                                        <Dropdown 
                                            value={form_data[field_name]} 
                                            onChange={(e) => inputChange(e)} 
                                            options={options} 
                                            optionLabel={optionLabel}
                                            optionValue={optionValue}
                                            placeholder={ 'Select ' + field_label }
                                            //className="w-100 custom-form-select" 
                                            className={`w-100 custom-form-select${errorInput(field_name)}`}
                                            checkmark={false} 
                                            highlightOnSelect={false}
                                            name={field_name}
                                            inputId={'input-' + field_name} 
                                        />
                                        <RenderErrors 
                                            errors={errors} 
                                            name={field_name} 
                                            className="text-error fs-7"
                                        />
                                    </div>
                    }
                    else if(field_type == 'option-amount'){
                        const options = field.option_list;
                        let optionProps = {value:'id', label:'name'}

                        if(field_name == 'country'){
                            optionProps =  {value:'name', label:'name'};
                        }

                        output =    <div className={column_class} key={`column-${field_name}`}>
                                        <label htmlFor={'input-' + field_name}>{displayLabel(field_label, custom_field_label, is_required)}</label>
                                        <Dropdown 
                                            value={form_data[field_name]} 
                                            onChange={(e) => inputChangeAmount(e, options)} 
                                            options={options} 
                                            optionLabel="name"
                                            optionValue="id"
                                            placeholder={ 'Select ' + field_label }
                                            //className="w-100 custom-form-select" 
                                            className={`w-100 custom-form-select${errorInput(field_name)}`}
                                            checkmark={false} 
                                            highlightOnSelect={true}
                                            name={field_name}
                                            inputId={'input-' + field_name} 
                                        />
                                        <RenderErrors 
                                            errors={errors} 
                                            name={field_name} 
                                            className="text-error fs-7"
                                        />
                                    </div>
                    }
                    else if(field_type == 'date'){
                        output =    <div className={column_class} key={`column-${field_name}`}>
                                        <InputText
                                            id={field_name} 
                                            name={field_name} 
                                            value={form_data[field_name]}      
                                            placeholder={ field_label } 
                                            label={displayLabel(field_label, custom_field_label, is_required)} 
                                            labelClass="form-label"
                                            //tagClass="form-control mb-0"
                                            tagClass={`form-control mb-0${errorInput(field_name)}`}
                                            type="date"
                                            onChange={inputChange}
                                        />
                                        <RenderErrors 
                                            errors={errors}
                                            name={field_name} 
                                            className="text-error fs-7"
                                        />
                                    </div>;
                    }

                    if(field_name === 'salutation'){
                        output = <>{output}<div className="col-lg-6" key="column-divider"></div></>
                    }

                    if(hide.includes(field_name)){
                        return;
                    }

                    return output;
                }
            });

            return input_fields;
        }
    }

    
                                
    return (
        <div className="row" id="wv-form-inputs">
            {/* Custom Fields */}
            {displayInputs()}
        </div>
    );
}

export default FormInputs;
